/**
 * Normalize get-message / room-by-id payloads to the room object.
 * Room-by-id returns `roomData`; get-message may use `room` / `chatRoom`.
 */
export function resolvePayloadRoom(payload) {
  if (!payload || typeof payload !== "object") return null;
  if (payload.roomData && typeof payload.roomData === "object") {
    return payload.roomData;
  }
  return (
    payload.room ||
    payload.chatRoom ||
    payload.data?.roomData ||
    payload.data?.room ||
    null
  );
}

/**
 * Resolve the group a live-chat room belongs to from room.group_id or room.groups[0].
 * @returns {{ id: string|null, name: string, image: string|null } | null}
 */
export function resolveRoomSourceGroup(room) {
  if (!room || typeof room !== "object") return null;

  const candidates = [];
  if (room.group_id && typeof room.group_id === "object") {
    candidates.push(room.group_id);
  }
  if (Array.isArray(room.groups)) {
    room.groups.forEach((g) => {
      if (g && typeof g === "object") candidates.push(g);
    });
  }

  const group = candidates.find((g) => g.name || g.title || g._id || g.id);
  if (!group) return null;

  const name = group.name || group.title || "";
  if (!name && !(group._id || group.id)) return null;

  return {
    id: group._id || group.id || null,
    name: name || "Group",
    image: group.group_image || group.image || null,
  };
}
